import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const TwitterLoginIcon = ({ className, color = Color.Twitter }: NewIconProps) => (
  <svg
    className={twMerge('size-[16px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.6749 7.98316C19.6869 8.15675 19.6869 8.33034 19.6869 8.50553C19.6869 13.8436 15.6231 20 8.19241 20V19.9968C5.99735 20 3.84788 19.3712 2 18.1857C2.31918 18.2241 2.63996 18.2433 2.96154 18.2441C4.78062 18.2457 6.54771 17.6353 7.97882 16.5114C6.25013 16.4786 4.73423 15.3515 4.20466 13.706C4.81022 13.8228 5.43418 13.7988 6.02855 13.6364C4.14386 13.2556 2.78795 11.5997 2.78795 9.67665C2.78795 9.65905 2.78795 9.64225 2.78795 9.62545C3.34951 9.93824 3.97828 10.1118 4.62143 10.131C2.84635 8.9447 2.29918 6.58325 3.37111 4.73696C5.42218 7.2608 8.44839 8.79511 11.697 8.9575C11.3714 7.55439 11.8162 6.08408 12.8657 5.09774C14.4928 3.56824 17.0519 3.64663 18.5814 5.27293C19.4861 5.09454 20.3532 4.76256 21.1468 4.29219C20.8452 5.22733 20.2141 6.02168 19.3709 6.52645C20.1717 6.43206 20.954 6.21767 21.6908 5.89049C21.1484 6.70324 20.4652 7.41119 19.6749 7.98316Z"
      fill={color}
    />
  </svg>
);
